































































import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';
import {
  SfButton,
  SfCarousel,
  SfLoader,
  SfProductCard,
  SfSection
} from '@storefront-ui/vue';

import { useImage } from '~/composables';
import { useAddToCart } from '~/helpers/cart/addToCart';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import { useUser } from '~/modules/customer/composables/useUser';
import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'ProductsCarousel',
  components: {
    SfCarousel,
    SfProductCard,
    SfSection,
    SfLoader,
    SfButton
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    products: {
      type: Array as PropType<Product[]>,
      required: false,
      default: () => []
    },
    loading: Boolean
  },
  setup() {
    const { isAuthenticated } = useUser();
    const { addItemToCart, isInCart } = useAddToCart();

    const { getMagentoImage, imageSizes } = useImage();

    return {
      addItemToCart,
      isAuthenticated,
      isInCart,
      productGetters,
      getMagentoImage,
      imageSizes
    };
  }
});
